import { Alert, Snackbar } from "@mui/material";
import type React from "react";

interface NotificationSnackbarsProps {
	errorMsg: string | null;
	successMsg: string | null;
	onCloseError: () => void;
	onCloseSuccess: () => void;
}

/**
 * Reusable component for displaying error and success notifications
 * using Material UI Snackbar and Alert components.
 */
export const NotificationSnackbars: React.FC<NotificationSnackbarsProps> = ({
	errorMsg,
	successMsg,
	onCloseError,
	onCloseSuccess,
}) => (
	<>
		<Snackbar open={!!errorMsg} autoHideDuration={4000} onClose={onCloseError}>
			<Alert
				onClose={onCloseError}
				severity="error"
				variant="filled"
				sx={{ width: "100%" }}
			>
				{errorMsg}
			</Alert>
		</Snackbar>
		<Snackbar
			open={!!successMsg}
			autoHideDuration={4000}
			onClose={onCloseSuccess}
		>
			<Alert
				onClose={onCloseSuccess}
				severity="success"
				variant="filled"
				sx={{ width: "100%" }}
			>
				{successMsg}
			</Alert>
		</Snackbar>
	</>
);
